/** Height of the top nav in px, at all breakpoints, for every layout. */
export const APP_HEADER_HEIGHT = 56;

/** CSS custom property holding the top nav height — set globally in App.tsx. */
export const APP_HEADER_HEIGHT_VAR = '--app-header-height';

/**
 * Use for anything that sticks or scrolls to just under the top nav
 * (e.g. `top` / `scrollMarginTop`). Reads the CSS variable rather than the
 * number so a layout can override it without touching consumers.
 */
export const APP_HEADER_OFFSET = `var(${APP_HEADER_HEIGHT_VAR})`;
